// extracted by mini-css-extract-plugin
export default {"sign_in":"Login_sign_in__wsCPk","wrapper":"Login_wrapper__zASbU","description":"Login_description__yq5CU"};